/* ENDQUOTE - motion & reveal system (2026-08-17), adapted from the Rory Mee
   reference site's interaction language. Progressive enhancement: without JS,
   in the theme editor, or under prefers-reduced-motion, everything renders
   fully visible and static. Remove this file + its script tag in
   layout/theme.liquid to revert. */

/* -- Scroll reveals with sibling stagger -- */
(function () {
	'use strict';
	if (window.Shopify && window.Shopify.designMode) return;
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
	if (!('IntersectionObserver' in window)) return;

	var TARGETS = [
		'#MainContent .card-wrapper',
		'#MainContent .multicolumn-card',
		'#MainContent .collection-banner__title',
		'#MainContent .rich-text__blocks',
		'#MainContent .collapsible-content__header',
		'#MainContent .product-details__title',
		'.footer-block'
		/* NEVER add: product form, price, payment buttons, cart elements */
	].join(',');

	var io = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (e) {
				if (e.isIntersecting) {
					e.target.classList.add('eq-in');
					io.unobserve(e.target);
				}
			});
		},
		{ threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
	);

	function tag(scope) {
		var els = scope.querySelectorAll(TARGETS);
		if (!els.length) return;
		document.documentElement.classList.add('eq-motion');
		els.forEach(function (el) {
			if (el.classList.contains('eq-reveal')) return;
			var parent = el.parentElement;
			var idx = 0;
			if (parent) {
				var sibs = Array.prototype.filter.call(parent.children, function (c) {
					return c.matches && c.matches(TARGETS);
				});
				idx = Math.min(Math.max(sibs.indexOf(el), 0), 4);
			}
			el.style.transitionDelay = idx * 0.08 + 's';
			el.classList.add('eq-reveal');
			io.observe(el);
		});
	}

	function init() { tag(document); }
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	document.addEventListener('shopify:section:load', function (e) {
		if (e.target) tag(e.target);
	});

	/* Safety valve: anything on-screen that never fired becomes visible. */
	setTimeout(function () {
		document.querySelectorAll('.eq-reveal:not(.eq-in)').forEach(function (el) {
			var r = el.getBoundingClientRect();
			if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('eq-in');
		});
	}, 4000);
})();

/* -- Sticky mobile Add To Cart pill (PDP only) -- */
(function () {
	'use strict';
	if (window.Shopify && window.Shopify.designMode) return;
	if (!('IntersectionObserver' in window)) return;
	if (!window.matchMedia('(max-width: 749px)').matches) return;
	/* Select the visible submit first - the page can contain a second, hidden
	   /cart/add form (Shopify installments) that would otherwise win the query. */
	var submit = document.querySelector('.product-form .product-form__submit, form[action*="/cart/add"] .product-form__submit');
	var form = submit && submit.closest('form');
	if (!form || !submit) return;

	var pill = document.createElement('button');
	pill.type = 'button';
	pill.className = 'eq-sticky-atc';
	function sync() {
		pill.disabled = submit.disabled;
		pill.textContent = (submit.textContent || 'Add To Cart').trim();
	}
	sync();
	pill.addEventListener('click', function () { submit.click(); });
	document.body.appendChild(pill);

	new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });

	var io = new IntersectionObserver(function (entries) {
		pill.classList.toggle('eq-sticky-atc--visible', !entries[0].isIntersecting);
	}, { rootMargin: '0px' });
	io.observe(submit);
})();

/* Lab labels (2026-08-17): mark heading-like lone-strong paragraphs in product
   descriptions. Letters-only + short — so emphasized data lines ("13.6 oz/yd2
   (460 g/m2)") stay ordinary bold text and only true section headers become labels. */
(function () {
	document.querySelectorAll('.product__description p > strong:only-child').forEach(function (s) {
		var t = (s.textContent || '').trim();
		if (t.length && t.length <= 28 && /^[A-Za-z][A-Za-z\s&\/\-]*$/.test(t)) {
			s.classList.add('eq-lab-label');
		}
	});
})();
